import { Box } from "@mui/material";
import { useFormikContext } from "formik";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { setActivePanel } from "../../../../../redux/slices/panelSlice";
import { dispatch } from "../../../../../redux/store";
import { getColor, globalScore } from "../../../seoAnalyzer/helper";
import "./styles.css";

export const SidePanel = () => {
  const { t } = useTranslation();
  const [result, setResult] = useState();
  const formikProps = useFormikContext();
  const competitorResults = useSelector(
    (state) => state.competitorAnalysis.data?.data
  );
  const scrollableRef = useRef(null);

  useEffect(() => {
    const scores = globalScore(formikProps, competitorResults);
    setResult(scores);
    formikProps.setFieldValue("seo_score", scores?.total_score);
  }, [formikProps.values, competitorResults]);
  const activePanel = useSelector((state) => state.panelSlice.activePanel);
  useEffect(() => {
    if (!activePanel) {
      scrollableRef?.current?.scrollTo(0, 0);
    }
  }, [activePanel]);
  return (
    <Box
      sx={{
        height: "100vh",
        color: "black",
        overflow: "scroll",
        px: "15px",
        pt: 3,
        width: { lg: "500px", md: "350px", xs: "100%" },
        bgcolor: "whitesmoke",
        borderLeft: "3px solid #e5e7eb",
      }}
      ref={scrollableRef}
      className="relative"
    >
      <div className=" pb-14">
        <p className="text-center font-semibold mb-4">
          {t("Page-analysis", "Analyse de la page")}
        </p>
        {result && (
          <>
            <div
              className={`text-end text-transparent bg-gradient-to-r pe-8 bg-clip-text ${getColor(
                result.total_score
              )}`}
              style={{ width: `${result.total_score}%` }}
            >
              {result.total_score}%
            </div>
            <div className="w-full relative p-2 rounded-xl bg-slate-300">
              <div
                className={`bg-gradient-to-r ${getColor(
                  result.total_score
                )} h-full  rounded-xl text-sm  absolute top-0 left-0`}
                style={{ width: `${result.total_score}%` }}
              ></div>
            </div>
          </>
        )}
        <div className="mb-4">
          <p className="font-semibold mb-2 mt-5">
            {t("Preparation", "Préparation")}
          </p>
          <div
            onClick={() => dispatch(setActivePanel("outline"))}
            className="panel-button"
          >
            {t("Outline", "Plan")}
            {result && (
              <>
                <div className="w-full relative p-1 rounded-xl bg-slate-300">
                  <div
                    className={`bg-gradient-to-r ${getColor(
                      result.plan
                    )} h-full  rounded-xl  absolute top-0 left-0`}
                    style={{ width: `${result.plan}%` }}
                  ></div>
                </div>
                <div
                  className={`text-end text-transparent bg-gradient-to-r  bg-clip-text  text-sm ${getColor(
                    result.plan
                  )}`}
                  style={{ width: `${result.plan}%` }}
                >
                  {result.plan}%
                </div>
              </>
            )}
          </div>
        </div>

        <div className="mb-4">
          <p className="font-semibold mb-2">{t("Redaction", "Rédaction")}</p>
          <div className="flex flex-col gap-5">
            <div
              onClick={() => dispatch(setActivePanel("urlSlug"))}
              className="panel-button"
            >
              {t("URL-Slug", "Slug d'URL")}
              {result && (
                <>
                  <div className="w-full relative p-1 rounded-xl bg-slate-300">
                    <div
                      className={`bg-gradient-to-r ${getColor(
                        result.url
                      )} h-full  rounded-xl  absolute top-0 left-0`}
                      style={{ width: `${result.url}%` }}
                    ></div>
                  </div>
                  <div
                    className={`text-end text-transparent bg-gradient-to-r  bg-clip-text text-sm ${getColor(
                      result.url
                    )}`}
                    style={{ width: `${result.url}%` }}
                  >
                    {result.url}%
                  </div>
                </>
              )}
            </div>
            <div
              onClick={() => dispatch(setActivePanel("h1Title"))}
              className="panel-button"
            >
              {t("H1-tag", "Titre (Balise H1)")}
              {result && (
                <>
                  <div className="w-full relative p-1 rounded-xl bg-slate-300">
                    <div
                      className={`bg-gradient-to-r ${getColor(
                        result.title
                      )} h-full  rounded-xl  absolute top-0 left-0`}
                      style={{ width: `${result.title}%` }}
                    ></div>
                  </div>
                  <div
                    className={`text-end text-transparent bg-gradient-to-r  bg-clip-text  text-sm ${getColor(
                      result.title
                    )}`}
                    style={{ width: `${result.title}%` }}
                  >
                    {result.title}%
                  </div>
                </>
              )}
            </div>
            <div
              onClick={() => dispatch(setActivePanel("content"))}
              className="panel-button"
            >
              {t("Content", "Contenu")}
              {result && (
                <>
                  <div className="w-full relative p-1 rounded-xl bg-slate-300">
                    <div
                      className={`bg-gradient-to-r ${getColor(
                        result.content
                      )} h-full  rounded-xl  absolute top-0 left-0`}
                      style={{ width: `${result.content}%` }}
                    ></div>
                  </div>
                  <div
                    className={`text-end text-transparent bg-gradient-to-r  bg-clip-text   text-sm ${getColor(
                      result.content
                    )}`}
                    style={{ width: `${result.content}%` }}
                  >
                    {result.content}%
                  </div>
                </>
              )}
            </div>
            <div
              onClick={() => dispatch(setActivePanel("metaData"))}
              className="panel-button"
            >
              {t("Metadatas", "Métadonnées")}
              {result && (
                <>
                  <div className="w-full relative p-1 rounded-xl bg-slate-300">
                    <div
                      className={`bg-gradient-to-r ${getColor(
                        result.metaData
                      )} h-full  rounded-xl  absolute top-0 left-0`}
                      style={{ width: `${result.metaData}%` }}
                    ></div>
                  </div>
                  <div
                    className={`text-end text-transparent bg-gradient-to-r  bg-clip-text text-sm ${getColor(
                      result.metaData
                    )}`}
                    style={{ width: `${result.metaData}%` }}
                  >
                    {result.metaData}%
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div>
          <p className="font-semibold mb-2">
            {t("Optimization", "Optimisation")}
          </p>
          <div className="flex flex-col gap-5">
            <div
              onClick={() => dispatch(setActivePanel("semantics"))}
              className="panel-button"
            >
              {t("Semantics", "Sémantique")}
              {result && (
                <>
                  <div className="w-full relative p-1 rounded-xl bg-slate-300">
                    <div
                      className={`bg-gradient-to-r ${getColor(
                        result.semantics
                      )} h-full  rounded-xl  absolute top-0 left-0`}
                      style={{ width: `${result.semantics}%` }}
                    ></div>
                  </div>
                  <div
                    className={`text-end text-transparent bg-gradient-to-r  bg-clip-text  text-sm ${getColor(
                      result.semantics
                    )}`}
                    style={{ width: `${result.semantics}%` }}
                  >
                    {result.semantics}%
                  </div>
                </>
              )}
            </div>
            <div
              onClick={() => dispatch(setActivePanel("mesh"))}
              className="panel-button"
            >
              {t(
                "Interna-and-external-linking",
                "Maillage (interne et externe)"
              )}
              {result && (
                <>
                  <div className="w-full relative p-1 rounded-xl bg-slate-300">
                    <div
                      className={`bg-gradient-to-r ${getColor(
                        result.linking
                      )} h-full  rounded-xl  absolute top-0 left-0`}
                      style={{ width: `${result.linking}%` }}
                    ></div>
                  </div>
                  <div
                    className={`text-end text-transparent bg-gradient-to-r  bg-clip-text  text-sm ${getColor(
                      result.linking
                    )}`}
                    style={{ width: `${result.linking}%` }}
                  >
                    {result.linking}%
                  </div>
                </>
              )}
            </div>
            <div
              onClick={() => dispatch(setActivePanel("medias"))}
              className="panel-button"
            >
              {t("Medias", "Médias (Images et vidéos)")}
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

const DesktopSidePanel = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        right: 0,
        padding: "10px",
        left: { sm: "unset", xs: 0 },
        mt: "48px",
        zIndex: 999,
      }}
    >
      <SidePanel />
    </Box>
  );
};

export default DesktopSidePanel;
